/* eslint-disable @nx/enforce-module-boundaries */
import {
  CalendarIcon,
  CausesIcon,
  EarthGlobeIcon,
  GlobeIcon,
  InterestIcon,
  LocationIcon,
  MailIcon,
  TeamIcon,
  OnlyMeLockIcon,
  LinkIcon,
  UnreadMessageIcon,
  AddCircle,
  AddCircleFIlled,
  TelephoneIcon,
  NewPlusIcon,
  CirclePlus
} from '@mybridge/icons';
import {
  HStack,
  Heading,
  IconButton,
  // Link,
  LinkButton,
  Stack,
  Tag,
  Text,
  VStack,
  Box,
  Tooltip,
  FormControl,
  FormLabel,
  Input,
  Button,
  PhoneNumberInput,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Checkbox,
  CheckboxGroup,
  Select,
  PopoverArrow,
  PopoverCloseButton,
  FormErrorMessage,
} from '@mybridge/ui';
import Link from 'next/link';
import { useContext, useEffect, useState } from 'react';
import { MyProfileContext } from '../context';
import { formatCommaSeparated, getUserLocation } from 'v4/lib/commons';
import { EditIcon } from '@mybridge/icons/Edit';
import { useDisclosure } from '@mybridge/ui';
import _ from 'lodash';
import { UserProfileIcon } from '@mybridge/icons/chat-icons';
import { TagsInput } from 'v4/components/tags-input';
import { LanguageDropdown } from 'v4/components/language-dropdown';
import moment from 'moment';
import { Calendar } from 'react-date-range';
import { ar, de, enUS, es, fr, hi, id, it, ja, ko, pt, ru, tr, vi, zhCN } from 'date-fns/locale';
import { LocationTagsInput } from 'v4/components/location-tags-input';
import { useDispatch } from 'react-redux';
import {
  getUserProfileInfo,
  updateUserDetails,
} from 'v4/store/actions/user-profile.actions';
import { causesYouCare, genderData, pronounsData } from 'v4/lib/data';
import { toPascalCase } from 'v4/components/utils';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const MyProfilePersonalInfo = () => {
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const {
    userProfileInfo,
    profileDisc,
    hasPersonalInfo,
    audienceDisc,
    setPermissionValue,
    profileFieldErrors,
    profileUpdateLoading,
    updateProfile,
    introductionDisc,
    setCurrentPermissionValue,
  } = useContext(MyProfileContext);
  const {
    city,
    email,
    mobile_number,
    language,
    lang,
    location,
    interested_in,
    causes_you_care,
    website,
    social_links,
    gender,
    pronouns,
    date_of_birth,
    iso_code,
  } = userProfileInfo ?? {};

  const causesFormatter = (causes_you_care, t) => {
    if (!causes_you_care) return "";

    const causesArr = causes_you_care.split(",").map((c) => c.trim());

    const translated = causesArr
      .map((cause) => {
        const match = causesYouCare.find((c) => c.value === cause);
        return match ? t(match.translationKey) : cause;
      })
      .filter(Boolean);

    return translated.join(", ");
  };

  const [updateProfileValue, setUpdateProfileValue] = useState(null);
  const [newIsoCode, setNewIsoCode] = useState(null);
  const [updateDob, setUpdateDob] = useState();
  const [updateCountry, setUpdateCountry] = useState();
  const [updateState, setUpdateState] = useState();
  const [updateCity, setUpdateCity] = useState();
  const [websiteList, setWebsiteList] = useState([]);
  const [socialLinksList, setSocialLinksList] = useState([]);
  const emailDisc = useDisclosure();
  const phoneDisc = useDisclosure();
  const languageDisc = useDisclosure();
  const dobDisc = useDisclosure();
  const locationDisc = useDisclosure();
  const interestsDisc = useDisclosure();
  const causesDisc = useDisclosure();
  const websiteDisc = useDisclosure();
  const socialDisc = useDisclosure();
  const genderDisc = useDisclosure();
  const pronounsDisc = useDisclosure();

  // const websiteRegex = /^(https:\/\/www\.|www\.)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/[^\s]*)?$/;
  const websiteRegex = /^((http|https):\/\/)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/[^\s]*)?$/i;

  // Array of all disclosure objects
  const disclosures = [
    emailDisc,
    phoneDisc,
    languageDisc,
    dobDisc,
    locationDisc,
    interestsDisc,
    causesDisc,
    websiteDisc,
    socialDisc,
    genderDisc,
    pronounsDisc,
  ];

  const localeMap = {
    ar,
    de,
    en: enUS,
    es,
    fr,
    hi,
    id,
    it,
    ja,
    ko,
    pt,
    ru,
    tr,
    vi,
    "zh-cn": zhCN,
  };

  // Function to close all disclosures except the one that was opened
  function handleDisclosureOpen(currentDisc) {
    setUpdateProfileValue(null);
    if (currentDisc === dobDisc) {
      setUpdateDob(date_of_birth ? moment.utc(date_of_birth).toDate() : new Date());
    } else {
      setUpdateDob();
    }
    disclosures.forEach((disc) => {
      if (disc !== currentDisc) {
        disc.onClose(); // Close others
      }
    });
    currentDisc.onOpen(); // Open the current one
  }

  const emailValue = _.get(userProfileInfo, 'field_audience.email');
  const phoneValue = _.get(userProfileInfo, 'field_audience.mobile_number');
  const languageValue = _.get(userProfileInfo, 'field_audience.lang');
  const locationValue = _.get(userProfileInfo, 'field_audience.location');
  const dobMonthValue = _.get(userProfileInfo, 'field_audience.dob_month');
  const dobYearValue = _.get(userProfileInfo, 'field_audience.dob_year');
  const interestedInValue = _.get(
    userProfileInfo,
    'field_audience.interested_in'
  );
  const causesYouCareValue = _.get(
    userProfileInfo,
    'field_audience.causes_you_care'
  );
  const websiteValue = _.get(userProfileInfo, 'field_audience.website');
  const socialLinksValue = _.get(
    userProfileInfo,
    'field_audience.social_links'
  );
  const genderValue = _.get(userProfileInfo, 'field_audience.gender');
  const pronounsValue = _.get(userProfileInfo, 'field_audience.pronouns');

  const renderPermissionSwitch = (param) => {
    switch (param) {
      case 1:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: t('profileDetails.public') || 'Public',
        };
      case 2:
        return {
          icon: <TeamIcon width="16px" height="16px" />,
          text: t('profileDetails.myNetwork') || 'myNetwork',
        };
      case 3:
        return {
          icon: <OnlyMeLockIcon width="16px" height="16px" />,
          text: t('profileDetails.onlyMe') || 'Only me',
        };
      default:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: t('profileDetails.public') || 'Public',
        };
    }
  };
  const mapProfileInfoIndividual = (param) => {
    switch (param) {
      case 'email':
        return {
          email: updateProfileValue,
        };
      case 'mobile_number': {
        // return {
        //   mobile_number: updateProfileValue,
        //   iso_code: newIsoCode.startsWith('+')
        //     ? `${newIsoCode}`
        //     : `+${newIsoCode}`,
        // };
        // Concatenate the ISO code with the mobile number
        const formattedIsoCode = newIsoCode?.startsWith('+') ? newIsoCode : `+${newIsoCode}`;
        return {
          // Combine ISO code and mobile number into a single field
          mobile_number: `${formattedIsoCode}${updateProfileValue}`,
        };
      }
      case 'language':
        return {
          language: updateProfileValue,
        };
      case 'dob': {
        // return {
        //   dob: moment(updateDob).local().format('YYYY-MM-DD'),
        // };
        const finalDob = updateDob ? moment(updateDob) : null;
        if (finalDob && finalDob.isValid()) {
          return {
            dob: finalDob.format('YYYY-MM-DD'),
          };
        }
        return {};
      }
      case 'location': {
        const updatedLocation = {};
        if (updateCity) updatedLocation.city = updateCity;
        if (updateState) updatedLocation.state = updateState;
        if (updateCountry) updatedLocation.country = updateCountry;
        if (updateCity || updateState || updateCountry) {
          const combinedLocation = [updateCity, updateState, updateCountry]
            .filter(Boolean)
            .join(', ');
          updatedLocation.location = combinedLocation;
        }
        return updatedLocation;
      }
      case 'interested_in':
        return {
          interested_in: formatCommaSeparated(updateProfileValue),
        };
      case 'causes_you_care':
        return {
          causes_you_care: formatCommaSeparated(updateProfileValue),
        };
      // case 'website':
      //   return {
      //     website: updateProfileValue,
      //   };
      case 'website':
        return {
          website: Array.isArray(updateProfileValue) 
            ? updateProfileValue.filter(link => link && link.trim() !== '') 
            : updateProfileValue
        };
      case 'social_links':
        return {
          social_links: Array.isArray(updateProfileValue) 
            ? updateProfileValue.filter(link => link && link.trim() !== '') 
            : updateProfileValue
        };
      case 'gender':
        return {
          gender: updateProfileValue,
        };
      case 'pronouns':
        return {
          pronouns: updateProfileValue,
        };
      default:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: 'Public',
        };
    }
  };
  const onSubmit = async (form) => {
    // delete form?.profile_banner_pic;
    // delete form?.profile_email;
    // delete form?.profile_pic;
    const payload = mapProfileInfoIndividual(form);

    // console.log(payload);
    if (form === 'location') {
      dispatch(updateUserDetails(payload)).then((res) => {
        locationDisc?.onClose();
        setUpdateCity();
        setUpdateCountry();
        setUpdateState();
        dispatch(getUserProfileInfo());
      });
    } else {
      updateProfile(payload).then((res) => {
        emailDisc?.onClose?.();
        phoneDisc?.onClose?.();
        languageDisc?.onClose();
        dobDisc?.onClose();
        locationDisc?.onClose();
        interestsDisc?.onClose();
        causesDisc?.onClose();
        websiteDisc?.onClose();
        socialDisc?.onClose();
        genderDisc?.onClose();
        pronounsDisc?.onClose();
        setUpdateProfileValue(null);
        setUpdateDob();
        setUpdateCity();
        setUpdateCountry();
        setUpdateState();
        setSocialLinksList([]);
      });
    }
  };

  useEffect(() => {
    if (phoneDisc.isOpen) {
      setUpdateProfileValue(mobile_number);
      setNewIsoCode(iso_code);
    }
    if (socialDisc.isOpen) {
      // Initialize with existing social links or empty array
      const existingSocialLinks = social_links 
        ? (Array.isArray(social_links) ? social_links : [social_links]).filter(link => link && link.trim() !== "")
        : [''];
      setSocialLinksList(existingSocialLinks.length > 0 ? existingSocialLinks : ['']);
      setUpdateProfileValue(existingSocialLinks.length > 0 ? existingSocialLinks : ['']);
    }
  }, [phoneDisc.isOpen, socialDisc.isOpen, social_links]);
  return (
    <VStack 
      // w={isMobile&&"92vw"} 
      align="stretch" 
      gap={4}
      pl={1}
    >
      <Heading fontSize="18px" fontWeight="400" color="#3D5A80">
      {t('profileDetails.profileDetails') || 'Profile details'}
      </Heading>
      {/* Email section start */}
      {email ? (
        <>
          <HStack
            spacing={4}
            justifyContent={email ? 'space-between' : 'flex-start'}
          >
            <HStack alignItems="flex-start">
              <MailIcon width={20} height={20} color="#868585" />
              <VStack alignItems="flex-start" gap={0}>
                <Text wordBreak="break-word" fontSize="15px" color="#868585">
                  {email}
                </Text>
                <Text fontSize="sm" color="#868585">
                  {t('profileDetails.email') || 'Email'}
                </Text>
              </VStack>
            </HStack>
            <HStack>
              <Tooltip label={renderPermissionSwitch(emailValue)?.text}>
                <IconButton
                  icon={renderPermissionSwitch(emailValue)?.icon}
                  size="sm"
                  variant="transparent"
                  onClick={() => {
                    audienceDisc.onOpen();
                    // handleDisclosureOpen(emailDisc);
                    setCurrentPermissionValue(emailValue);
                    setPermissionValue('email');
                  }}
                />
              </Tooltip>
              <Popover placement="top-end">
                <PopoverTrigger>
                  <IconButton
                    icon={<EditIcon width="16px" height="16px" />}
                    size="sm"
                    variant="transparent"
                    aria-label={t('buttons.edit') || 'Edit'}
                  />
                </PopoverTrigger>
                <PopoverContent>
                  <PopoverArrow />
                  <PopoverCloseButton />
                  <PopoverBody pr={10} color="#868585" fontSize="12px">
                    {t('profileDetails.checkYour') || "Check your"}{' '}
                    <Link href={'/settings/account'}>{t('profileDetails.settingAccount') || "setting/account"}</Link> {t('profileDetails.manageEmailAddresses') || "to manage your email addresses."}
                  </PopoverBody>
                </PopoverContent>
              </Popover>
            </HStack>
          </HStack>
        </>
      ) : (
        <>
          <Button
            leftIcon={<AddCircleFIlled width="20" height="20" />}
            width="fit-content"
            variant="transparent"
            color="brandPrimary.500"
            pl={0}
          >
            {' '}
            {t('profileDetails.addEmail') || 'Add Email'}
          </Button>
        </>
      )}

      {/* Phone section start */}
      {!phoneDisc.isOpen ? (
        mobile_number ? (
          <HStack spacing={4} justifyContent="space-between">
            <HStack alignItems="flex-start">
              <TelephoneIcon width={20} height={20} color="#868585" />
              <VStack alignItems="flex-start" gap={0}>
                <Text fontSize="15px" color="#868585">
                  {iso_code} {mobile_number}
                </Text>
                <Text fontSize="sm" color="#868585">
                  {t('profileDetails.mobileNumber') || 'Mobile Number'}
                </Text>
              </VStack>
            </HStack>
            <HStack>
              <Tooltip label={renderPermissionSwitch(phoneValue)?.text}>
                <IconButton
                  icon={renderPermissionSwitch(phoneValue)?.icon}
                  size="sm"
                  variant="transparent"
                  onClick={() => {
                    audienceDisc.onOpen();
                    setCurrentPermissionValue(phoneValue);
                    setPermissionValue('mobile_number');
                  }}
                />
              </Tooltip>
              <Tooltip label={t('buttons.edit') || 'Edit'}>
                <IconButton
                  icon={<EditIcon width="16px" height="16px" />}
                  size="sm"
                  variant="transparent"
                  onClick={() => {
                    handleDisclosureOpen(phoneDisc);
                    phoneDisc?.onOpen();
                  }}
                />
              </Tooltip>
            </HStack>
          </HStack>
        ) : (
          isMobile ? 
          <Button
            leftIcon={null} // Remove the default positioning of the icon
            width="100%" // Adjust to desired width; fit-content will limit its flexibility
            justifyContent="space-between" // Ensure icon moves to the end
            variant="transparent"
            color={isMobile ? '#747474' : 'brandPrimary.500'}
            onClick={() => {
              handleDisclosureOpen(phoneDisc);
              phoneDisc?.onOpen();
            }}
            pl={0}
          >
            <Box opacity={0.5}> {t('profileDetails.addMobileNumber') || 'Add mobile number'}</Box>
            <NewPlusIcon
              width="20"
              height="20"
            />
          </Button> :
          <Button
            leftIcon={<AddCircleFIlled width="20" height="20" />}
            width="fit-content"
            variant="transparent"
            color="brandPrimary.500"
            onClick={() => {
              handleDisclosureOpen(phoneDisc);
              phoneDisc?.onOpen();
            }}
            pl={0}
          >
            {' '}
            {t('profileDetails.addMobileNumber') || 'Add mobile number'}
          </Button>
        )
      ) : (
        <Box>
          <FormControl>
            <FormLabel>{t('profileDetails.mobileNumber') || 'Mobile Number'}</FormLabel>
            {/* <Input
              defaultValue={profile_mobile_number}
              placeholder=" "
              onChange={(e) => setUpdateProfileValue(e.target.value)}
            /> */}
            <PhoneNumberInput
              value={mobile_number}
              defaultDialCode={iso_code}
              onChange={(e) => setUpdateProfileValue(e)}
              onDailCodeChange={(e) => setNewIsoCode(e)}
            />
          </FormControl>
          <HStack justifyContent="space-between" mt={6}>
            <HStack>
              <Button
                borderRadius="50px"

                type="button"
                onClick={() => {
                  audienceDisc.onOpen();
                  setCurrentPermissionValue(phoneValue);
                  setPermissionValue('mobile_number');
                }}
                leftIcon={renderPermissionSwitch(phoneValue)?.icon}
              >
                {renderPermissionSwitch(phoneValue)?.text}
              </Button>
            </HStack>

            <HStack>
              <Button
                onClick={(e) => phoneDisc?.onClose?.()}
                variant="secondary"
                borderRadius="50px"
              >
                {t('buttons.cancel') || 'Cancel'}
              </Button>
              <Button
                borderRadius="50px"
                isLoading={profileUpdateLoading}
                type="button"
                variant="primary"
                onClick={() => onSubmit('mobile_number')}
              >
                {t('buttons.save') || 'Save'}
              </Button>
            </HStack>
          </HStack>
        </Box>
      )}

      {/* Language section start */}
      {!languageDisc.isOpen ? (
        language?.length ? (
          <HStack spacing={4} justifyContent="space-between">
            <HStack alignItems="flex-start">
              <GlobeIcon width={20} height={20} color="#868585" />
              <VStack alignItems="flex-start" gap={0}>
                <Text fontSize="15px" color="#868585">
                  {language?.map?.((lang, index) => (
                    <Box as="span" key={index}>
                      {lang}
                      {index < language.length - 1 && ', '}
                    </Box>
                  ))}
                </Text>
                <Text fontSize="sm" color="#868585">
                  {t('profileDetails.languages') || 'Languages'}
                </Text>
              </VStack>
            </HStack>
            <HStack>
              <Tooltip label={renderPermissionSwitch(languageValue)?.text}>
                <IconButton
                  icon={renderPermissionSwitch(languageValue)?.icon}
                  size="sm"
                  variant="transparent"
                  onClick={() => {
                    audienceDisc.onOpen();
                    setCurrentPermissionValue(languageValue);
                    setPermissionValue('lang');
                  }}
                />
              </Tooltip>
              <Tooltip label={t('buttons.edit') || 'Edit'}>
                <IconButton
                  icon={<EditIcon width="16px" height="16px" />}
                  size="sm"
                  variant="transparent"
                  onClick={() => {
                    handleDisclosureOpen(languageDisc);
                    languageDisc.onOpen();
                  }}
                />
              </Tooltip>
            </HStack>
          </HStack>
        ) : (
          isMobile ? 
            <Button
              leftIcon={null} // Remove the default positioning of the icon
              width="100%" // Adjust to desired width; fit-content will limit its flexibility
              justifyContent="space-between" // Ensure icon moves to the end
              variant="transparent"
              color={isMobile ? '#747474' : 'brandPrimary.500'}
              onClick={() => {
                handleDisclosureOpen(languageDisc);
                languageDisc.onOpen();
              }}
              pl={0}
            >
              <Box opacity={0.5}>{t('profileDetails.addLanguage') || 'Add language'}</Box>
              <NewPlusIcon
                width="20"
                height="20"
              />
            </Button> :
          <Button
            leftIcon={<AddCircleFIlled width="20" height="20" />}
            width="fit-content"
            variant="transparent"
            color="brandPrimary.500"
            onClick={() => {
              handleDisclosureOpen(languageDisc);
              languageDisc.onOpen();
            }}
            pl={0}
          >
            {' '}
            <Box opacity={0.5}>{t('profileDetails.addLanguage') || 'Add language'}</Box>
          </Button>
        )
      ) : (
        <Box>
          <FormControl>
            <FormLabel>{t('profileDetails.languages') || 'Languages'}</FormLabel>
            <TagsInput
              title="Languages"
              value={language}
              onChange={(e) => setUpdateProfileValue(e)}
            >
              {({ addTag, setEdit }) => (
                <LanguageDropdown
                  allowCreate
                  onChange={(obj) => {
                    addTag?.(obj?.name);
                    setEdit(false);
                  }}
                >
                  {(input) => (
                    <Input
                      {...(input ?? {})}
                      borderRadius="full"
                      onClick={(e) => input?.disc?.onOpen?.()}
                      onChange={(e) => input?.onChange(e.target.value)}
                      placeholder={t('profileDetails.typeToSearch') || 'Type to search...'}
                      onKeyUp={(e) => {
                        input?.onKeyUp?.(e);
                        if (e.keyCode === 27) {
                          setEdit(false);
                        }
                      }}
                      autoFocus
                      sx={{ textTransform: 'capitalize' }}
                    />
                  )}
                </LanguageDropdown>
              )}
            </TagsInput>
          </FormControl>
          <HStack justifyContent="space-between" mt={6}>
            <HStack>
              <Button
                borderRadius="50px"
                type="button"
                onClick={() => {
                  audienceDisc.onOpen();
                  setCurrentPermissionValue(languageValue);
                  setPermissionValue('language');
                }}
                leftIcon={renderPermissionSwitch(languageValue)?.icon}
              >
                {renderPermissionSwitch(languageValue)?.text}
              </Button>
            </HStack>

            <HStack>
              <Button
                borderRadius="50px"
                onClick={(e) => languageDisc?.onClose?.()}
                variant="secondary"
              >
                {t('buttons.cancel') || 'Cancel'}
              </Button>
              <Button
                borderRadius="50px"
                isLoading={profileUpdateLoading}
                type="button"
                variant="primary"
                onClick={() => onSubmit('language')}
                isDisabled={!updateProfileValue || (Array.isArray(updateProfileValue) && updateProfileValue.filter(val => val && val.trim()).length === 0)}
              >
                {t('buttons.save') || 'Save'}
              </Button>
            </HStack>
          </HStack>
        </Box>
      )}
      {/* Date of brith section start */}
      {!dobDisc.isOpen ? (
        date_of_birth ? (
          <HStack
            spacing={4}
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <HStack alignItems="flex-start" w="100%">
              <CalendarIcon width={20} height={20} color="#868585" />
              <Stack align="stretch" flex={1}>
                <HStack justifyContent="space-between">
                  <VStack alignItems="flex-start" gap={0}>
                    <Text fontSize="15px" color="#868585">
                      {/* {moment(date_of_birth).utc().format('MMMM DD')} */}
                      {moment.utc(date_of_birth).format('MMMM DD')}
                    </Text>
                    <Text fontSize="sm" color="#868585" mb={3}>
                      {t('profileDetails.birthDate') || 'Birth Date'}
                    </Text>
                  </VStack>
                  <HStack alignItems="flex-start">
                    <Tooltip
                      label={renderPermissionSwitch(dobMonthValue)?.text}
                    >
                      <IconButton
                        icon={renderPermissionSwitch(dobMonthValue)?.icon}
                        size="sm"
                        variant="transparent"
                        onClick={() => {
                          audienceDisc.onOpen();
                          setCurrentPermissionValue(dobMonthValue);
                          setPermissionValue('dob_month');
                        }}
                      />
                    </Tooltip>
                    <Tooltip label={t('buttons.edit') || 'Edit'}>
                      <IconButton
                        icon={<EditIcon width="16px" height="16px" />}
                        size="sm"
                        variant="transparent"
                        onClick={() => {
                          handleDisclosureOpen(dobDisc);
                          dobDisc?.onOpen();
                        }}
                      />
                    </Tooltip>
                  </HStack>
                </HStack>
                <HStack justifyContent="space-between">
                  <VStack alignItems="flex-start" gap={0}>
                    <Text fontSize="15px" color="#868585">
                      {/* {moment(date_of_birth).format('YYYY')} */}
                      {moment.utc(date_of_birth).format('YYYY')}
                    </Text>
                    <Text fontSize="sm" color="#868585">
                      {t('profileDetails.birthYear') || 'Birth Year'}
                    </Text>
                  </VStack>
                  <HStack alignItems="flex-start">
                    <Tooltip label={renderPermissionSwitch(dobYearValue)?.text}>
                      <IconButton
                        icon={renderPermissionSwitch(dobYearValue)?.icon}
                        size="sm"
                        variant="transparent"
                        onClick={() => {
                          audienceDisc.onOpen();
                          setCurrentPermissionValue(dobYearValue);
                          setPermissionValue('dob_year');
                        }}
                      />
                    </Tooltip>
                    <Tooltip label={t('buttons.edit') || 'Edit'}>
                      <IconButton
                        icon={<EditIcon width="16px" height="16px" />}
                        size="sm"
                        variant="transparent"
                        onClick={() => {
                          handleDisclosureOpen(dobDisc);
                          dobDisc?.onOpen();
                        }}
                      />
                    </Tooltip>
                  </HStack>
                </HStack>
              </Stack>
            </HStack>
          </HStack>
        ) : (
          isMobile ? 
            <Button
              leftIcon={null} // Remove the default positioning of the icon
              width="100%" // Adjust to desired width; fit-content will limit its flexibility
              justifyContent="space-between" // Ensure icon moves to the end
              variant="transparent"
              color={isMobile ? '#747474' : 'brandPrimary.500'}
              onClick={() => {
                handleDisclosureOpen(dobDisc);
                dobDisc.onOpen();
              }}
              pl={0}
            >
              <Box opacity={0.5}>{t('profileDetails.addDateOfBirth') || 'Add date of birth'}</Box>
              <NewPlusIcon
                width="20"
                height="20"
              />
            </Button> :
          <Button
            leftIcon={<AddCircleFIlled width="20" height="20" />}
            width="fit-content"
            variant="transparent"
            color="brandPrimary.500"
            onClick={() => {
              handleDisclosureOpen(dobDisc);
              dobDisc.onOpen();
            }}
            pl={0}
          >
            {' '}
            <Box opacity={0.5}>{t('profileDetails.addDateOfBirth') || 'Add date of birth'}</Box>
          </Button>
        )
      ) : (
        <Box>
          <Popover>
            <PopoverTrigger>
              <FormControl variant="floating">
                <Input
                  placeholder=""
                  value={
                    updateDob
                      ? moment(updateDob).format('MMMM DD, YYYY')
                      : ''
                  }
                />
                <FormLabel>{t('profileDetails.dateOfBirth') || 'Date of birth'}</FormLabel>
              </FormControl>
            </PopoverTrigger>
            <PopoverContent width="360px">
              <PopoverBody>
                <Calendar
                  onChange={(item) => {
                    setUpdateDob(item);
                  }}
                  date={updateDob ? updateDob : new Date()}
                  locale={localeMap[lang] || enUS} 
                  maxDate={new Date()}
                />
              </PopoverBody>
            </PopoverContent>
          </Popover>

          <HStack justifyContent="space-between" mt={6}>
            <HStack>
              <Button
              borderRadius="50px"
                type="button"
                onClick={() => {
                  audienceDisc.onOpen();
                  setCurrentPermissionValue(dobYearValue);
                  setPermissionValue('dob');
                }}
                leftIcon={renderPermissionSwitch(dobYearValue)?.icon}
              >
                {renderPermissionSwitch(dobYearValue)?.text}
              </Button>
            </HStack>

            <HStack>
              <Button 
                borderRadius="50px"
              onClick={(e) => dobDisc?.onClose?.()} variant="secondary">
                {t('buttons.cancel') || 'Cancel'}
              </Button>
              <Button
              borderRadius="50px"
                isLoading={profileUpdateLoading}
                type="button"
                variant="primary"
                onClick={() => onSubmit('dob')}
              >
                {t('buttons.save') || 'Save'}
              </Button>
            </HStack>
          </HStack>
        </Box>
      )}

      {/* Location section start */}
      {city ? (
        <>
          <HStack
            spacing={4}
            justifyContent="space-between"
          >
            <HStack alignItems="flex-start">
              <LocationIcon width={20} height={20} color="#868585" />
              <VStack alignItems="flex-start" gap={0}>
                {/* {userProfileInfo?.city && <Text wordBreak="break-word" fontSize="15px" color="#868585">
                  {userProfileInfo?.city ? userProfileInfo.city + ', ' : ''}
                  {userProfileInfo?.state ? userProfileInfo.state + ', ' : ''}
                  {userProfileInfo?.country ? userProfileInfo.country : ''}
                </Text>} */}
                <Text wordBreak="break-word" fontSize="15px" color="#868585">
                  {userProfileInfo?.location}
                </Text>
                <Text fontSize="sm" color="#868585">
                  {t('profileDetails.location') || 'Location'}
                </Text>
              </VStack>
            </HStack>
            <HStack>
              <Tooltip label={renderPermissionSwitch(locationValue)?.text}>
                <IconButton
                  icon={renderPermissionSwitch(locationValue)?.icon}
                  size="sm"
                  variant="transparent"
                  onClick={() => {
                    audienceDisc.onOpen();
                    setCurrentPermissionValue(locationValue);
                    setPermissionValue('location');
                  }}
                />
              </Tooltip>
              <Popover placement="top-end">
                <PopoverTrigger>
                  <IconButton
                    icon={<EditIcon width="16px" height="16px" />}
                    size="sm"
                    variant="transparent"
                    aria-label={t('buttons.edit') || 'Edit'}
                  />
                </PopoverTrigger>
                <PopoverContent>
                  <PopoverArrow />
                  <PopoverCloseButton />
                  <PopoverBody pr={10} color="#868585" fontSize="12px">
                    {t('profileDetails.checkYour') || "Check your"}{' '}
                    <Link href={'/settings/account'}>{t('profileDetails.settingAccount') || "setting/account"}</Link> 
                    {" "}to manage your location
                  </PopoverBody>
                </PopoverContent>
              </Popover>
            </HStack>
          </HStack>
        </>
      ) : (
        <>
          <Button
            leftIcon={<AddCircleFIlled width="20" height="20" />}
            width="fit-content"
            variant="transparent"
            color="brandPrimary.500"
            pl={0}
          >
            {' '}
            {t('profileDetails.addLocation') || 'Add location'}
          </Button>
        </>
      )}

      {/* Interest section start */}
      {!interestsDisc.isOpen ? (
        interested_in ? (
          <HStack spacing={4} justifyContent="space-between">
            <HStack alignItems="flex-start">
              <InterestIcon width={20} height={20} color="#868585" />
              <VStack alignItems="flex-start" gap={0}>
                <Text fontSize="15px" color="#868585" sx={{ textTransform: 'capitalize' }}>
                  {interested_in}
                </Text>
                <Text fontSize="sm" color="#868585">
                  {t('profileDetails.interests') || 'Interests'}
                </Text>
              </VStack>
            </HStack>
            <HStack>
              <Tooltip label={renderPermissionSwitch(interestedInValue)?.text}>
                <IconButton
                  icon={renderPermissionSwitch(interestedInValue)?.icon}
                  size="sm"
                  variant="transparent"
                  onClick={() => {
                    audienceDisc.onOpen();
                    setCurrentPermissionValue(interestedInValue);
                    setPermissionValue('interested_in');
                  }}
                />
              </Tooltip>
              <Tooltip label={t('buttons.edit') || 'Edit'}>
                <IconButton
                  icon={<EditIcon width="16px" height="16px" />}
                  size="sm"
                  variant="transparent"
                  onClick={() => {
                    handleDisclosureOpen(interestsDisc);
                    interestsDisc.onOpen();
                  }}
                />
              </Tooltip>
            </HStack>
          </HStack>
        ) : (
          isMobile ? 
            <Button
              leftIcon={null} // Remove the default positioning of the icon
              width="100%" // Adjust to desired width; fit-content will limit its flexibility
              justifyContent="space-between" // Ensure icon moves to the end
              variant="transparent"
              color={isMobile ? '#747474' : 'brandPrimary.500'}
              onClick={() => {
                handleDisclosureOpen(interestsDisc);
                interestsDisc.onOpen();
              }}
              pl={0}
            >
              <Box opacity={0.5}>{t('profileDetails.addInterests') || 'Add interests'}</Box>
              <NewPlusIcon
                width="20"
                height="20"
              />
            </Button>
           : 
          <Button
            leftIcon={<AddCircleFIlled width="20" height="20" />}
            width="fit-content"
            variant="transparent"
            color="brandPrimary.500"
            onClick={() => {
              handleDisclosureOpen(interestsDisc);
              interestsDisc.onOpen();
            }}
            pl={0}
          >
            {' '}
            <Box opacity={0.5}>{t('profileDetails.addInterests') || 'Add interests'}</Box>
          </Button>
        )
      ) : (
        <Box>
          <FormControl>
            <FormLabel>{t('profileDetails.interests') || 'Interests'}</FormLabel>
            <TagsInput
              value={
                updateProfileValue
                  ? updateProfileValue
                  : interested_in
                  ? interested_in?.split(',')
                  : ''
              }
              onChange={(e) => setUpdateProfileValue(e)}
            />
          </FormControl>

          <HStack justifyContent="space-between" mt={6}>
            <HStack>
              <Button
              borderRadius="50px"
                type="button"
                onClick={() => {
                  audienceDisc.onOpen();
                  setCurrentPermissionValue(interestedInValue);
                  setPermissionValue('interested_in');
                }}
                leftIcon={renderPermissionSwitch(interestedInValue)?.icon}
              >
                {renderPermissionSwitch(interestedInValue)?.text}
              </Button>
            </HStack>

            <HStack>
              <Button
              borderRadius="50px"
                onClick={(e) => interestsDisc?.onClose?.()}
                variant="secondary"
              >
                {t('buttons.cancel') || 'Cancel'}
              </Button>
              <Button
              borderRadius="50px"
                isLoading={profileUpdateLoading}
                type="button"
                variant="primary"
                onClick={() => onSubmit('interested_in')}
                isDisabled={!updateProfileValue || (Array.isArray(updateProfileValue) && updateProfileValue.filter(val => val && val.trim()).length === 0)}
              >
                {t('buttons.save') || 'Save'}
              </Button>
            </HStack>
          </HStack>
        </Box>
      )}

      {/* Causes section start */}
      {!causesDisc.isOpen ? (
        causes_you_care ? (
          <HStack spacing={4} justifyContent="space-between">
            <HStack alignItems="flex-start">
              <Box>
                <CausesIcon width={20} height={20} color="#868585" />
              </Box>
              <VStack alignItems="flex-start" gap={0}>
                <Text fontSize="15px" color="#868585">
                  {causesFormatter(causes_you_care, t)}
                </Text>
                <Text fontSize="sm" color="#868585">
                  {t('profileDetails.causesYouCareAbout') || 'Causes you care about'}
                </Text>
              </VStack>
            </HStack>
            <HStack>
              <Tooltip label={renderPermissionSwitch(causesYouCareValue)?.text}>
                <IconButton
                  icon={renderPermissionSwitch(causesYouCareValue)?.icon}
                  size="sm"
                  variant="transparent"
                  onClick={() => {
                    audienceDisc.onOpen();
                    setCurrentPermissionValue(causesYouCareValue);
                    setPermissionValue('causes_you_care');
                  }}
                />
              </Tooltip>
              <Tooltip label={t('buttons.edit') || 'Edit'}>
                <IconButton
                  icon={<EditIcon width="16px" height="16px" />}
                  size="sm"
                  variant="transparent"
                  onClick={() => {
                    handleDisclosureOpen(causesDisc);
                    causesDisc.onOpen();
                  }}
                />
              </Tooltip>
            </HStack>
          </HStack>
        ) : (
          isMobile ? 
          <Button
            leftIcon={null} // Remove the default positioning of the icon
            width="100%" // Adjust to desired width; fit-content will limit its flexibility
            justifyContent="space-between" // Ensure icon moves to the end
            variant="transparent"
            color={isMobile ? '#747474' : 'brandPrimary.500'}
            onClick={() => {
              handleDisclosureOpen(causesDisc);
              causesDisc.onOpen();
            }}
            pl={0}
          >
            <Box opacity={0.5}>{t('profileDetails.addCausesYouCareAbout') || 'Add Causes you care about?'}</Box>
            <NewPlusIcon
              width="20"
              height="20"
            />
          </Button> :
          <Button
            leftIcon={<AddCircleFIlled width="20" height="20" />}
            width="fit-content"
            variant="transparent"
            color="brandPrimary.500"
            onClick={() => {
              handleDisclosureOpen(causesDisc);
              causesDisc.onOpen();
            }}
            pl={0}
          >
            {' '}
            <Box opacity={0.5}>{t('profileDetails.addCausesYouCareAbout') || 'Add Causes you care about?'}</Box>
          </Button>
        )
      ) : (
        <Box>
          <FormControl>
            <FormLabel>{t('profileDetails.causesYouCareAbout') || 'Causes you care about'}</FormLabel>
            <CheckboxGroup
              value={
                updateProfileValue
                  ? updateProfileValue
                  : causes_you_care?.split(',').map((item) => item.trim())
              }
              onChange={(e) => setUpdateProfileValue(e)}
            >
              <Stack>
                {causesYouCare.map((cyc, cycIndex) => (
                  <Checkbox key={cycIndex} value={cyc.value}>
                    {/* {toPascalCase(cyc)} */}
                    {t(cyc.translationKey)}
                  </Checkbox>
                ))}
              </Stack>
            </CheckboxGroup>
          </FormControl>

          <HStack justifyContent="space-between" mt={6}>
            <HStack>
              <Button
              borderRadius="50px"
                type="button"
                onClick={() => {
                  audienceDisc.onOpen();
                  setCurrentPermissionValue(causesYouCareValue);
                  setPermissionValue('causes_you_care');
                }}
                leftIcon={renderPermissionSwitch(causesYouCareValue)?.icon}
              >
                {renderPermissionSwitch(causesYouCareValue)?.text}
              </Button>
            </HStack>

            <HStack>
              <Button
              borderRadius="50px"
                onClick={(e) => causesDisc?.onClose?.()}
                variant="secondary"
              >
                {t('buttons.cancel') || 'Cancel'}
              </Button>
              <Button
                borderRadius="50px"
                isLoading={profileUpdateLoading}
                type="button"
                variant="primary"
                onClick={() => onSubmit('causes_you_care')}
                isDisabled={!updateProfileValue?.[1] || !updateProfileValue?.length}
              >
                {t('buttons.save') || 'Save'}
              </Button>
            </HStack>
          </HStack>
        </Box>
      )}
      {/* Website section starts */}
      {!websiteDisc.isOpen ? (
        <>
          {/* Display all websites together like in public profile */}
          {website && (Array.isArray(website) ? website : [website]).length > 0 && (
            <HStack alignItems="flex-start">
              <GlobeIcon width={20} height={20} color="#868585" />
              <VStack alignItems="flex-start" gap={0}>
                <Box display="flex" flexDirection="column" fontSize="15px" color="#868585">
                  {(Array.isArray(website) ? website : [website]).map((link, i) => (
                    <Link
                      key={i}
                      href={link.startsWith("http") ? link : `https://${link}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      display="block"
                    >
                      {link}
                    </Link>
                  ))}
                </Box>
                <Text fontSize="sm" color="#868585">
                  {t('profileDetails.website') || 'Website'}
                </Text>
              </VStack>
              <HStack ml="auto">
                <Tooltip label={renderPermissionSwitch(websiteValue)?.text}>
                  <IconButton
                    icon={renderPermissionSwitch(websiteValue)?.icon}
                    size="sm"
                    variant="transparent"
                    onClick={() => {
                      audienceDisc.onOpen();
                      setCurrentPermissionValue(websiteValue);
                      setPermissionValue('website');
                    }}
                  />
                </Tooltip>
                <Tooltip label={t('buttons.edit') || 'Edit'}>
                  <IconButton
                    icon={<EditIcon width="16px" height="16px" />}
                    size="sm"
                    variant="transparent"
                    onClick={() => {
                      handleDisclosureOpen(websiteDisc);
                      // Initialize with existing websites
                      const existingWebsites = Array.isArray(website) ? website : [website];
                      setWebsiteList(existingWebsites);
                      setUpdateProfileValue(existingWebsites);
                      websiteDisc.onOpen();
                    }}
                  />
                </Tooltip>
              </HStack>
            </HStack>
          )}
          
          {/* Add website button - always visible */}
          {isMobile ? 
            <Button
              leftIcon={null}
              width="100%"
              justifyContent="space-between"
              variant="transparent"
              color={isMobile ? '#747474' : 'brandPrimary.500'}
              onClick={() => {
                handleDisclosureOpen(websiteDisc);
                // Initialize with existing websites or empty array
                const existingWebsites = website 
                  ? (Array.isArray(website) ? website : [website])
                  : [];
                setWebsiteList(existingWebsites);
                setUpdateProfileValue(existingWebsites);
                websiteDisc.onOpen();
              }}
              pl={0}
            >
              <Box opacity={0.5}>
                {website ? ('Add another website') : (t('profileDetails.addWebsite') || 'Add a website')}
              </Box>
              <NewPlusIcon width="20" height="20" />
            </Button> :
            <Button
              leftIcon={<AddCircleFIlled width="20" height="20" />}
              width="fit-content"
              variant="transparent"
              color="brandPrimary.500"
              onClick={() => {
                handleDisclosureOpen(websiteDisc);
                // Initialize with existing websites or empty array
                const existingWebsites = website 
                  ? (Array.isArray(website) ? website : [website])
                  : [];
                setWebsiteList(existingWebsites);
                setUpdateProfileValue(existingWebsites);
                websiteDisc.onOpen();
              }}
              pl={0}
            >
              <Box opacity={0.5}>
                {website?.length ? ('Add another website') : (t('profileDetails.addWebsite') || 'Add a website')}
              </Box>
            </Button>
          }
        </>
      ) : (
        <Box>
          <FormControl isInvalid={websiteList.some(link => link && !websiteRegex.test(link))}>
            <FormLabel>{t('profileDetails.website') || 'Website'}</FormLabel>
            <VStack align="stretch" spacing={3}>
              {websiteList.map((link, index) => (
                <HStack key={index} spacing={2}>
                  <Input
                    placeholder=""
                    value={link}
                    onChange={(e) => {
                      const newList = [...websiteList];
                      newList[index] = e.target.value;
                      setWebsiteList(newList);
                      setUpdateProfileValue(newList.length === 1 ? newList[0] : newList);
                    }}
                  />
                  {/* {websiteList.length > 1 && (
                    <IconButton
                      icon={<EditIcon width="16px" height="16px" />}
                      size="sm"
                      variant="ghost"
                      colorScheme="red"
                      onClick={() => {
                        const newList = websiteList.filter((_, i) => i !== index);
                        setWebsiteList(newList);
                        setUpdateProfileValue(newList.length === 1 ? newList[0] : newList);
                      }}
                      aria-label="Remove website"
                    />
                  )} */}
                </HStack>
              ))}
              
              {/* Add new website input button */}
              <Box>
                <Button
                  leftIcon={<CirclePlus width="20" height="20" />}
                  p={6}
                  borderRadius="full"
                  variant="secondary"
                  isDisabled={websiteList?.some(link => !link || link.trim().length === 0)}
                  color="brandPrimary.500"
                  onClick={() => {
                    const newList = [...websiteList, ''];
                    setWebsiteList(newList);
                  }}
                  bg="transparent"
                >
                  {formatCommaSeparated([t('createJob.add') || 'Add', ''], ' ')}
                </Button>
              </Box>
            </VStack>
            {websiteList.some(link => link && !websiteRegex.test(link)) && (
              <FormErrorMessage>
                {t('createPage.pleaseEnterValidURL') || "Please enter a valid URL"}
              </FormErrorMessage>
            )}
          </FormControl>

          <HStack justifyContent="space-between" mt={6}>
            <HStack>
              <Button
                borderRadius="50px"
                type="button"
                onClick={() => {
                  audienceDisc.onOpen();
                  setCurrentPermissionValue(websiteValue);
                  setPermissionValue('website');
                }}
                leftIcon={renderPermissionSwitch(websiteValue)?.icon}
              >
                {renderPermissionSwitch(websiteValue)?.text}
              </Button>
            </HStack>

            <HStack>
              <Button
                borderRadius="50px"
                onClick={(e) => {
                  websiteDisc?.onClose?.();
                  setWebsiteList([]);
                }}
                variant="secondary"
              >
                {t('buttons.cancel') || 'Cancel'}
              </Button>
              <Button
                borderRadius="50px"
                isLoading={profileUpdateLoading}
                type="button"
                variant="primary"
                onClick={() => onSubmit('website')}
                isDisabled={websiteList.some(link => link && !websiteRegex.test(link)) || websiteList.every(link => !link || link.trim() === '')}
              >
                {t('buttons.save') || 'Save'}
              </Button>
            </HStack>
          </HStack>
        </Box>
      )}
      {/* Social section start */}
      {!socialDisc.isOpen ? (
        <>
          {/* Display all social links together like in public profile */}
          {social_links && (Array.isArray(social_links) ? social_links : [social_links]).filter(link => link && link.trim() !== "").length > 0 && (
            <HStack alignItems="flex-start">
              <LinkIcon width={20} height={20} color="#868585" />
              <VStack alignItems="flex-start" gap={0}>
                <Box display="flex" flexDirection="column" fontSize="15px" color="#868585">
                  {(Array.isArray(social_links) ? social_links : [social_links])
                    .filter(link => link && link.trim() !== "")
                    .map((link, i) => (
                      <Link
                        key={i}
                        href={link.startsWith("http") ? link : `https://${link}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        display="block"
                      >
                        {link}
                      </Link>
                    ))}
                </Box>
                <Text fontSize="sm" color="#868585">
                  {t('profileDetails.socialLinks') || 'Social Links'}
                </Text>
              </VStack>
              <HStack ml="auto">
                <Tooltip label={renderPermissionSwitch(socialLinksValue)?.text}>
                  <IconButton
                    icon={renderPermissionSwitch(socialLinksValue)?.icon}
                    size="sm"
                    variant="transparent"
                    onClick={() => {
                      audienceDisc.onOpen();
                      setCurrentPermissionValue(socialLinksValue);
                      setPermissionValue('social_links');
                    }}
                  />
                </Tooltip>
                <Tooltip label={t('buttons.edit') || 'Edit'}>
                  <IconButton
                    icon={<EditIcon width="16px" height="16px" />}
                    size="sm"
                    variant="transparent"
                    onClick={() => {
                      handleDisclosureOpen(socialDisc);
                      // Initialize with existing social links
                      const existingSocialLinks = social_links 
                        ? (Array.isArray(social_links) ? social_links : [social_links]).filter(link => link && link.trim() !== "")
                        : [''];
                      setSocialLinksList(existingSocialLinks.length > 0 ? existingSocialLinks : ['']);
                      setUpdateProfileValue(existingSocialLinks.length > 0 ? existingSocialLinks : ['']);
                      socialDisc.onOpen();
                    }}
                  />
                </Tooltip>
              </HStack>
            </HStack>
          )}
          
          {/* Add social link button - always visible */}
          {isMobile ? 
            <Button
              leftIcon={null}
              width="100%"
              justifyContent="space-between"
              variant="transparent"
              color={isMobile ? '#747474' : 'brandPrimary.500'}
              onClick={() => {
                handleDisclosureOpen(socialDisc);
                // Initialize with existing social links or empty array
                const existingSocialLinks = social_links 
                  ? (Array.isArray(social_links) ? social_links : [social_links]).filter(link => link && link.trim() !== "")
                  : [''];
                setSocialLinksList(existingSocialLinks.length > 0 ? existingSocialLinks : ['']);
                setUpdateProfileValue(existingSocialLinks.length > 0 ? existingSocialLinks : ['']);
                socialDisc.onOpen();
              }}
              pl={0}
            >
              <Box opacity={0.5}>
                {social_links && (Array.isArray(social_links) ? social_links : [social_links]).some(link => link && link.trim() !== "") 
                  ? ('Add another social link') 
                  : (t('profileDetails.addSocialLink') || 'Add a social link')}
              </Box>
              <NewPlusIcon width="20" height="20" />
            </Button> :
            <Button
              leftIcon={<AddCircleFIlled width="20" height="20" />}
              width="fit-content"
              variant="transparent"
              color="brandPrimary.500"
              onClick={() => {
                handleDisclosureOpen(socialDisc);
                // Initialize with existing social links or empty array
                const existingSocialLinks = social_links 
                  ? (Array.isArray(social_links) ? social_links : [social_links]).filter(link => link && link.trim() !== "")
                  : [''];
                setSocialLinksList(existingSocialLinks.length > 0 ? existingSocialLinks : ['']);
                setUpdateProfileValue(existingSocialLinks.length > 0 ? existingSocialLinks : ['']);
                socialDisc.onOpen();
              }}
              pl={0}
            >
              <Box opacity={0.5}>
                {social_links && (Array.isArray(social_links) ? social_links : [social_links]).some(link => link && link.trim() !== "") 
                  ? ('Add another social link') 
                  : (t('profileDetails.addSocialLink') || 'Add a social link')}
              </Box>
            </Button>
          }
        </>
      ) : (
        <Box>
          <FormControl isInvalid={socialLinksList.some(link => link && !/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/.test(link.trim()))}>
            <FormLabel>{t('profileDetails.socialLinks') || 'Social Links'}</FormLabel>
            <VStack align="stretch" spacing={3}>
              {socialLinksList.map((link, index) => (
                <HStack key={index} spacing={2}>
                  <Input
                    placeholder=""
                    value={link}
                    onChange={(e) => {
                      const newList = [...socialLinksList];
                      newList[index] = e.target.value;
                      setSocialLinksList(newList);
                      setUpdateProfileValue(newList.length === 1 ? newList[0] : newList);
                    }}
                  />
                  {/* {socialLinksList.length > 1 && (
                    <IconButton
                      icon={<EditIcon width="16px" height="16px" />}
                      size="sm"
                      variant="ghost"
                      colorScheme="red"
                      onClick={() => {
                        const newList = socialLinksList.filter((_, i) => i !== index);
                        setSocialLinksList(newList);
                        setUpdateProfileValue(newList.length === 1 ? newList[0] : newList);
                      }}
                      aria-label="Remove social link"
                    />
                  )} */}
                </HStack>
              ))}
              
              {/* Add new social link input button */}
              <Box>
                <Button
                  leftIcon={<CirclePlus width="20" height="20" />}
                  p={6}
                  borderRadius="full"
                  variant="secondary"
                  isDisabled={socialLinksList?.some(link => !link || link.trim().length === 0)}
                  color="brandPrimary.500"
                  onClick={() => {
                    const newList = [...socialLinksList, ''];
                    setSocialLinksList(newList);
                  }}
                  bg="transparent"
                >
                  {formatCommaSeparated([t('createJob.add') || 'Add', ''], ' ')}
                </Button>
              </Box>
            </VStack>
            {socialLinksList.some(link => link && !/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/.test(link.trim())) && (
              <FormErrorMessage>
                {'Please enter a valid URL (e.g., https://example.com)'}
              </FormErrorMessage>
            )}
          </FormControl>
          <HStack justifyContent="space-between" mt={6}>
            <HStack>
              <Button
              borderRadius="50px"
                type="button"
                onClick={() => {
                  audienceDisc.onOpen();
                  setCurrentPermissionValue(socialLinksValue);
                  setPermissionValue('social_links');
                }}
                leftIcon={renderPermissionSwitch(socialLinksValue)?.icon}
              >
                {renderPermissionSwitch(socialLinksValue)?.text}
              </Button>
            </HStack>

            <HStack>
              <Button
              borderRadius="50px"
                onClick={(e) => {
                  socialDisc?.onClose?.();
                  setSocialLinksList([]);
                }}
                variant="secondary"
              >
                {t('buttons.cancel') || 'Cancel'}
              </Button>
              <Button
              borderRadius="50px"
                isLoading={profileUpdateLoading}
                type="button"
                variant="primary"
                onClick={() => onSubmit('social_links')}
                isDisabled={socialLinksList.some(link => link && !/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/.test(link.trim())) || socialLinksList.every(link => !link || link.trim() === '')}
              >
                {t('buttons.save') || 'Save'}
              </Button>
            </HStack>
          </HStack>
        </Box>
      )}

      {/* Gender section starts */}
      {!genderDisc.isOpen ? (
        gender ? (
          <HStack spacing={4} justifyContent="space-between">
            <HStack alignItems="flex-start">
              <UserProfileIcon width={20} height={20} color="#868585" />
              <VStack alignItems="flex-start" gap={0}>
                <Text fontSize="15px" color="#868585">
                  {gender}
                </Text>
                <Text fontSize="sm" color="#868585">
                  {t('profileDetails.gender') || 'Gender'}
                </Text>
              </VStack>
            </HStack>
            <HStack>
              <Tooltip label={renderPermissionSwitch(genderValue)?.text}>
                <IconButton
                  icon={renderPermissionSwitch(genderValue)?.icon}
                  size="sm"
                  variant="transparent"
                  onClick={() => {
                    audienceDisc.onOpen();
                    setCurrentPermissionValue(genderValue);
                    setPermissionValue('gender');
                  }}
                />
              </Tooltip>
              <Tooltip label={t('buttons.edit') || 'Edit'}>
                <IconButton
                  icon={<EditIcon width="16px" height="16px" />}
                  size="sm"
                  variant="transparent"
                  onClick={() => {
                    handleDisclosureOpen(genderDisc);
                    genderDisc.onOpen();
                  }}
                />
              </Tooltip>
            </HStack>
          </HStack>
        ) : (
          isMobile ? 
          <Button
            leftIcon={null} // Remove the default positioning of the icon
            width="100%" // Adjust to desired width; fit-content will limit its flexibility
            justifyContent="space-between" // Ensure icon moves to the end
            variant="transparent"
            color={isMobile ? '#747474' : 'brandPrimary.500'}
            onClick={() => {
              handleDisclosureOpen(genderDisc);
              genderDisc.onOpen();
            }}
            pl={0}
          >
            <Box opacity={0.5}>{t('profileDetails.gender') || 'Gender'}</Box>
            <NewPlusIcon
              width="20"
              height="20"
            />
          </Button> :
          <Button
            leftIcon={<AddCircleFIlled width="20" height="20" />}
            width="fit-content"
            variant="transparent"
            color="brandPrimary.500"
            onClick={() => {
              handleDisclosureOpen(genderDisc);
              genderDisc.onOpen();
            }}
            pl={0}
          >
            <Box opacity={0.5}>{t('profileDetails.gender') || 'Gender'}</Box>
          </Button>
        )
      ) : (
        <Box>
          <FormControl variant="floating">
            <Select
              onChange={(e) => setUpdateProfileValue(e.target.value)}
              variant="whiteInput"
            >
              <option>{t('profileDetails.selectGender') || 'Select Gender'}</option>
              {genderData?.map((gender, i) => (
                <option key={i} value={gender?.value}>
                  {t(gender?.translationKey)}
                </option>
              ))}
            </Select>
            <FormLabel>{t('profileDetails.gender') || 'Gender'}</FormLabel>
          </FormControl>

          <HStack justifyContent="space-between" mt={6}>
            <HStack>
              <Button
              borderRadius="50px"
                type="button"
                onClick={() => {
                  audienceDisc.onOpen();
                  setCurrentPermissionValue(genderValue);
                  setPermissionValue('gender');
                }}
                leftIcon={renderPermissionSwitch(genderValue)?.icon}
              >
                {renderPermissionSwitch(genderValue)?.text}
              </Button>
            </HStack>

            <HStack>
              <Button
              borderRadius="50px"
                onClick={(e) => genderDisc?.onClose?.()}
                variant="secondary"
              >
                {t('buttons.cancel') || 'Cancel'}
              </Button>
              <Button
              borderRadius="50px"
                isLoading={profileUpdateLoading}
                type="button"
                variant="primary"
                onClick={() => onSubmit('gender')}
              >
                {t('buttons.save') || 'Save'}
              </Button>
            </HStack>
          </HStack>
        </Box>
      )}

      {/* Pronouns section starts */}
      {!pronounsDisc.isOpen ? (
        pronouns ? (
          <HStack spacing={4} justifyContent="space-between">
            <HStack alignItems="flex-start">
              <UnreadMessageIcon width={20} height={20} color="#868585" />
              <VStack alignItems="flex-start" gap={0}>
                <Text fontSize="15px" color="#868585">
                  {pronouns}
                </Text>
                <Text fontSize="sm" color="#868585">
                  {t('profileDetails.pronouns') || 'Pronouns'}
                </Text>
              </VStack>
            </HStack>
            <HStack>
              <Tooltip label={renderPermissionSwitch(pronounsValue)?.text}>
                <IconButton
                  icon={renderPermissionSwitch(pronounsValue)?.icon}
                  size="sm"
                  variant="transparent"
                  onClick={() => {
                    audienceDisc.onOpen();
                    setCurrentPermissionValue(pronounsValue);
                    setPermissionValue('pronouns');
                  }}
                />
              </Tooltip>
              <Tooltip label={t('buttons.edit') || 'Edit'}>
                <IconButton
                  icon={<EditIcon width="16px" height="16px" />}
                  size="sm"
                  variant="transparent"
                  onClick={() => {
                    handleDisclosureOpen(pronounsDisc);
                    pronounsDisc.onOpen();
                  }}
                />
              </Tooltip>
            </HStack>
          </HStack>
        ) : (
          isMobile ? 
          <Button
            leftIcon={null} // Remove the default positioning of the icon
            width="100%" // Adjust to desired width; fit-content will limit its flexibility
            justifyContent="space-between" // Ensure icon moves to the end
            variant="transparent"
            color={isMobile ? '#747474' : 'brandPrimary.500'}
            onClick={() => {
              handleDisclosureOpen(pronounsDisc);
              pronounsDisc.onOpen();
            }}
            pl={0}
          >
            <Box opacity={0.5}>{t('profileDetails.systemPronouns') || 'System pronouns'}</Box>
            <NewPlusIcon
              width="20"
              height="20"
            />
          </Button> :
          <Button
            leftIcon={<AddCircleFIlled width="20" height="20" />}
            width="fit-content"
            variant="transparent"
            color="brandPrimary.500"
            onClick={() => {
              handleDisclosureOpen(pronounsDisc);
              pronounsDisc.onOpen();
            }}
            pl={0}
          >
            <Box opacity={0.5}>{t('profileDetails.systemPronouns') || 'System pronouns'}</Box>
          </Button>
        )
      ) : (
        <Box>
          <FormControl variant="floating">
            <Select
              onChange={(e) => setUpdateProfileValue(e.target.value)}
              variant="whiteInput"
            >
              <option>{t('profileDetails.selectPronouns') || 'Select Pronouns'}</option>
              {pronounsData?.map((gender, i) => (
                <option key={i} value={gender?.value}>
                  {t(gender?.translationKey)}
                </option>
              ))}
            </Select>
            <FormLabel>{t('profileDetails.pronouns') || 'Pronouns'}</FormLabel>
          </FormControl>

          <HStack justifyContent="space-between" mt={6}>
            <HStack>
              <Button
              borderRadius="50px"
                type="button"
                onClick={() => {
                  audienceDisc.onOpen();
                  setCurrentPermissionValue(pronounsValue);
                  setPermissionValue('pronouns');
                }}
                leftIcon={renderPermissionSwitch(pronounsValue)?.icon}
              >
                {renderPermissionSwitch(pronounsValue)?.text}
              </Button>
            </HStack>

            <HStack>
              <Button
              borderRadius="50px"
                onClick={(e) => pronounsDisc?.onClose?.()}
                variant="secondary"
              >
                {t('buttons.cancel') || 'Cancel'}
              </Button>
              <Button
              borderRadius="50px"
                isLoading={profileUpdateLoading}
                type="button"
                variant="primary"
                onClick={() => onSubmit('pronouns')}
              >
                {t('buttons.save') || 'Save'}
              </Button>
            </HStack>
          </HStack>
        </Box>
      )}
    </VStack>
  );
};
